/*
 * lazy-loader.js -- shared "load once" utility for non-critical assets.
 *
 * Both interaction triggers and idle warm-ups call loadOnce(), keyed by a
 * string, so a CSS/JS resource is fetched at most once no matter how many
 * callers ask for it. Used by sr-checkout (Fastrr) to keep heavy
 * third-party libraries off the critical render path.
 *
 * Loaded with `defer` and BEFORE its consumers, so window.LazyLoad is ready
 * when their deferred scripts run.
 */
(function () {
  if (window.LazyLoad) return;

  var cache = {}; // key -> Promise that resolves when the resource has loaded

  // loadOnce(key, { css: url })  or  loadOnce(key, { js: url, module, defer })
  // A <link>/<script> injected here is added after parse, so it never blocks render.
  function loadOnce(key, opts) {
    if (cache[key]) return cache[key];
    cache[key] = new Promise(function (resolve, reject) {
      var el;
      if (opts.css) {
        el = document.createElement('link');
        el.rel = 'stylesheet';
        el.href = opts.css;
      } else {
        el = document.createElement('script');
        el.src = opts.js;
        if (opts.module) el.type = 'module';
        if (opts.defer) el.defer = true;
      }
      el.onload = function () { resolve(); };
      el.onerror = function (err) { delete cache[key]; reject(err); };
      (document.head || document.documentElement).appendChild(el);
    });
    return cache[key];
  }

  function loaded(key) {
    return Object.prototype.hasOwnProperty.call(cache, key);
  }

  // Run fn during the first idle gap after the page settles (timeout fallback
  // so it always fires even on a busy page).
  function idle(fn, timeout) {
    timeout = timeout || 5000;
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: timeout });
    } else {
      setTimeout(fn, Math.min(timeout, 3000));
    }
  }

  window.LazyLoad = { loadOnce: loadOnce, loaded: loaded, idle: idle };

  // Shared id helpers for analytics payloads. Consolidated here so every
  // consumer builds cart/session ids the same way. Google Sheets logging was
  // removed 2026-09-04; these now feed the GA4 dataLayer and Clarity only.

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function getSessionId() {
    var id = sessionStorage.getItem('fastrrSessionId');
    if (!id) {
      id = uuid();
      sessionStorage.setItem('fastrrSessionId', id);
    }
    return id;
  }

  function getCartToken() {
    var match = document.cookie.match(/(?:^|; )cart=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  window.EventLog = { uuid: uuid, getSessionId: getSessionId, getCartToken: getCartToken };
})();
